
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/2fyrir1",
      function () {
        return require("private-next-pages/2fyrir1/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/2fyrir1"])
      });
    }
  